import * as React from 'react'
import { useParams } from 'react-router-dom';
import { FrontPageKPI, getKPI, getProjectById } from '../../globals/ApiHooks';
import Project, { ProjectId } from '../../shared/Project';
import { NiceIntrestRate, NiceNumberWithCurrency } from '../../shared/UIFormatting';
import colors from '../../globals/colors';
import { Body, ColumnFlexBox, Container, RowFlexBox } from '../../components/templates/Wrappers';
import CompletionChart, { IconSizes } from '../../components/molecules/CompletionChart';
import { translateContent } from '../../globals/Translations';
import { GetDurationString } from '../../components/atoms/ProjectCard';

export const PromotionUIPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: ProjectId }>()
  const [project, setProject] = React.useState<Project>()

  const [kpi, setKPI] = React.useState<FrontPageKPI>()

  React.useEffect(() => {
    (async () => {
      if (projectId) {
        const result = await getProjectById(projectId)
        const kpiResult = await getKPI()
        setKPI(kpiResult)
        setProject(result)
      }
    })()
  }, [projectId])


  if (!project || !kpi) return <></>

  const image = project.images[0]
  const percent = Math.floor((project.finance.currentFunding / project.finance.targetFunding) * 100)

  const progressId = "progress-content-" + projectId
  const interestRateId = "interest-rate-content-" + projectId
  const emailImageid = "email-content-" + projectId


  return (
    <Body>
      <Container>
        <h1>Project marketing tools</h1>
        <ColumnFlexBox style={{ alignItems: 'flex-start' }}>
          <p><b>Marketing tools overview</b></p>
          <a href={"#" + progressId}>Progress image</a>
          <a href={"#" + interestRateId}>Interest rate image</a>
          <a href={"#" + emailImageid}>Email image</a>

        </ColumnFlexBox>
        <h3 style={{ marginTop: 100 }}>Progress image</h3>
        <div style={{ width: 800, height: 600 }} id={progressId}>
          <div style={{
            width: 800, height: 500, backgroundImage: 'url(' + image + ')', backgroundPosition: 'center', backgroundSize: 'cover'
          }}>
            <RowFlexBox style={{ alignItems: 'center', paddingTop: 10 }}>
              <img style={{ marginLeft: 10 }} width="140px" src="https://emailsignature.trustpilot.com/signature/en-US/1/5fd7af0e88d51f0001bcf2cc/stars.png" />
              <img style={{ marginLeft: 10 }} width="140px" src="https://emailsignature.trustpilot.com/brand/n/1/logo_dark.png" />
            </RowFlexBox>
            <ColumnFlexBox style={{ justifyContent: 'center', alignItems: 'center', marginTop: 70 }}>
              <CompletionChart iconSize={IconSizes.XLarge} percent={percent} />
            </ColumnFlexBox>
          </div>
          <div style={{
            fontFamily: 'sans-serif', color: colors.grayText,
            fontSize: 20, lineHeight: 1, padding: 10, letterSpacing: 0.6, fontVariant: 'normal',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
              <span>Kapital formidlet siden 2020</span> <span>{kpi.capital}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
              <span>Udbetalinger siden 2021</span> <span>{kpi.payments}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
              <span>Investor siden 2020</span> <span>{kpi.investors}</span>
            </div>
          </div>
        </div>
        <h3 style={{ marginTop: 100 }}>Interest rate image</h3>
        <div style={{ width: 800, height: 600 }} id={interestRateId}>
          <div style={{
            width: 800, height: 500, backgroundImage: 'url(' + image + ')', backgroundPosition: 'center', backgroundSize: 'cover'
          }}>
            <RowFlexBox style={{ alignItems: 'center', paddingTop: 10 }}>
              <img style={{ marginLeft: 10 }} width="140px" src="https://emailsignature.trustpilot.com/signature/en-US/1/5fd7af0e88d51f0001bcf2cc/stars.png" />
              <img style={{ marginLeft: 10 }} width="140px" src="https://emailsignature.trustpilot.com/brand/n/1/logo_dark.png" />
            </RowFlexBox>
            <ColumnFlexBox style={{ justifyContent: 'center', alignItems: 'center', marginTop: 70 }}>
              <ColumnFlexBox style={{
                backgroundColor: colors.lightest, justifyContent: 'center', alignItems: 'center',
                width: 250, height: 250, borderRadius: 250, borderWidth: 10, borderColor: colors.primary, borderStyle: 'solid'
              }}>
                <img width="200" height="44"
                  src="https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/59c23268-89c9-4132-9a6c-c97a7aa61eff.png" />
                <h4 style={{ margin: 0, padding: 0, fontFamily: 'sans-serif' }}>{NiceIntrestRate(project.finance.interestRate)} årlig rente</h4>
              </ColumnFlexBox>
            </ColumnFlexBox>
          </div>
          <div style={{
            fontFamily: 'sans-serif', color: colors.grayText,
            fontSize: 20, lineHeight: 1, padding: 10, letterSpacing: 0.6, fontVariant: 'normal',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
              <span>Kapital formidlet siden 2020</span> <span>{kpi.capital}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
              <span>Udbetalinger siden 2021</span> <span>{kpi.payments}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
              <span>Investor siden 2020</span> <span>{kpi.investors}</span>
            </div>
          </div>
        </div>
        <h3 style={{ marginTop: 100 }}>Email image</h3>
        <div style={{ width: 800, height: 270 }} id={emailImageid}>
          <div style={{
            width: 800, height: 270, backgroundImage: 'url(' + image + ')', backgroundPosition: 'center', backgroundSize: 'cover'
          }} >
            <RowFlexBox style={{ fontFamily: 'sans-serif', color: colors.grayText, justifyContent: 'space-between' }}>
              <RowFlexBox style={{ alignItems: 'flex-start', paddingTop: 10 }}>
                <img style={{ marginLeft: 10 }} width="140px" src="https://emailsignature.trustpilot.com/signature/en-US/1/5fd7af0e88d51f0001bcf2cc/stars.png" />
                <img style={{ marginLeft: 10 }} width="140px" src="https://emailsignature.trustpilot.com/brand/n/1/logo_dark.png" />
              </RowFlexBox>
              <ColumnFlexBox style={{
                width: 300, height: 270, padding: 10,
                backgroundColor: colors.lightest, opacity: 0.85, justifyContent: 'space-between'
              }}>
                <ColumnFlexBox style={{ textAlign: 'left' }}>
                  <span style={{ color: colors.dark, fontSize: 20 }}><b>{translateContent(project.projectTitle)}</b></span>
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
                    <span>Fast årlig rente</span> <span>{NiceIntrestRate(project.finance.interestRate)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
                    <span>Projektstørrelse</span> <span>{NiceNumberWithCurrency(project.finance.targetFunding)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
                    <span>Løbetid</span> <span>{GetDurationString(project)}</span>
                  </div>
                </ColumnFlexBox>
                <img width="300" height="66"
                  src="https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/59c23268-89c9-4132-9a6c-c97a7aa61eff.png" />

              </ColumnFlexBox>
            </RowFlexBox>

          </div>
        </div>
      </Container>

    </Body>
  )
}
